// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/2d0d4c83/" + chunkId + "." + __webpack_require__.h() + ".v2d0d4c83.js";
};